import { Box, Flex, IconButton, Image, VStack } from "@chakra-ui/react";
import { useLocation } from "react-router";
import { Icon } from "@equidefi/ui/icon";
import EquidefiLogo from "../../images/logo-white.png";
import { IssuerInfo, NavMenu, UserGreeting, WorkflowProgress, PoweredBySection } from "./components";
import { useAuth } from "@equidefi/portals/hooks/useAuth";

export const NavDesktopView = ({ position, offering, logout, menu }) => {
  const MenuIcon = menu.isOpen ? Icon.X : Icon.Menu;
  const { pathname } = useLocation();
  const isAdditionalSignerPage = pathname.includes("/investment/signer");
  const { isLoggedIn } = useAuth();

  return (
    <Flex
      position="fixed"
      direction="column"
      w="400px"
      zIndex="2"
      color="white"
      p="10"
      bgColor={offering?.issuer?.brand_color || "primary"}
      minH="full"
      align="start"
      justify="space-around">
      {position === 1 && !isLoggedIn ? (
        <>
          <IssuerInfo offering={offering} isLargeScreen isWideLogo />
        </>
      ) : (
        <>
          {offering && position ? (
            <IconButton
              aria-label={menu.isOpen ? "Hide Menu" : "Open Menu"}
              icon={<MenuIcon size="2em" />}
              variant="unstyled"
              onClick={menu.onToggle}
            />
          ) : (
            <Image
              src={offering?.issuer?.wide_logo_url || EquidefiLogo}
              alt={offering?.issuer?.name || "EquiDeFi"}
              maxW="283px"
              maxH="72px"
              objectFit="contain"
              alignSelf="center"
              mt={3}
            />
          )}
          {!offering || menu.isOpen ? (
            <Box w="full">
              <UserGreeting />
              <NavMenu logout={logout} offering={offering} />
              <Box w="full" alignSelf="center" mt="8em" mb="-5em">
                <PoweredBySection />
              </Box>
            </Box>
          ) : (
            <VStack gap="4" w="full">
              <IssuerInfo offering={offering} isLargeScreen isWideLogo />
              <WorkflowProgress offering={offering} position={position} />
              {isAdditionalSignerPage && (
                <Box w="full">
                  <NavMenu
                    logout={logout}
                    menu={menu}
                    isAdditionalSignerPage={isAdditionalSignerPage}
                    offering={offering}
                  />
                </Box>
              )}

              <Box w="full" alignSelf="center" mt="8em" mb="-4em">
                <PoweredBySection />
              </Box>
            </VStack>
          )}
        </>
      )}
      {/* <Icon.HelpCircle size="2em" cursor="pointer" className="intercom" /> */}
    </Flex>
  );
};
